import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import creators from './actions';
import QualifiedPlayerCardItem from '../../qualified-player-card/js/QualifiedPlayerCardItem';
import app from '../../../general/js/app';

class QualifiedGolfersPreview extends React.Component {
    getPlayersToShow() {
        if (app.isDesktopWide) {
            return 5;
        } if (app.isDesktop) {
            return 4;
        } if (app.isTablet) {
            return 3;
        }

        return 2;
    }

    getPreviewPlayers() {
        return this.props.previewPlayers.slice(0, this.getPlayersToShow());
    }


    render() {
        const previewPlayers = this.getPreviewPlayers();
        const morePlayersCount = this.props.totalPlayersCount - previewPlayers.length;

        return (
            <div className="qualified-golfers__preview">
                <div className="qualified-golfers__title">
                    {this.props.translations.title}
                </div>
                <div className="qualified-golfers__preview-players">
                    <div className="qualified-golfers-preview-players">
                        <ul className="qualified-golfers-preview-players__list">
                            {previewPlayers.map((item, i) => (
                                <li className="qualified-golfers-preview-players__item"
                                    key={item.id}>
                                    <QualifiedPlayerCardItem index={i} item={item}/>
                                </li>
                            ))}
                        </ul>
                        <div className="qualified-golfers-preview-players__more">
                            {morePlayersCount > 0 ? (
                                <span>
                                    + {morePlayersCount}
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>
                <button onClick={this.props.onShowEventsClick}
                    className="button button--secondary qualified-golfers__show-events-button"
                    type="button">
                    <span className="button-content">
                        Show previous events
                        <svg width="12" height="12"
                            className="icon qualified-golfers__show-events-icon">
                            <use xlinkHref="#icon-arrow-right"></use>
                        </svg>
                    </span>
                </button>
            </div>
        );
    }
}

QualifiedGolfersPreview.propTypes = {
    deviceType: PropTypes.string.isRequired,
    totalPlayersCount: PropTypes.number.isRequired,
    translations: PropTypes.object.isRequired,
    previewPlayers: PropTypes.array.isRequired,
    onShowEventsClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    const {
        translations, previewPlayers, totalPlayersCount, deviceType
    } = state;
    return {
        translations, previewPlayers, totalPlayersCount, deviceType
    };
};

const mapDispatchToProps = (dispatch) => ({
    onShowEventsClick: () => {
        dispatch(creators.showPreviousEvents());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(QualifiedGolfersPreview);
